var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (continueBtnText, doneText, hasNarration, hasPrompt, i18n, prompt, submitUp, tappies, title, undefined) {
jade_mixins["image"] = jade_interp = function(imageUrl, klass){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<img" + (jade.attr("src", imageUrl, true, false)) + (jade.cls([klass], [true])) + "/>");
};
buf.push("<div class=\"block-v-lg content-fill text-center\"><div class=\"tappies-parent content-fill\"><div class=\"thumbnail-collection content-sm-ver content-md-ver content-lg-ver\"><div class=\"title-wrapper\"><h1 class=\"title slide-down delay-3 tight\">" + (null == (jade_interp = title) ? "" : jade_interp) + "</h1></div><div class=\"row tappies text-center\">");
var full = "col-sm-12 col-lg-8 col-lg-offset-2"
var half = "col-sm-6 col-lg-6"
// iterate tappies
;(function(){
  var $$obj = tappies;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var tappy = $$obj[i];

buf.push("<div" + (jade.attr("data-index", i, true, false)) + (jade.cls(['tappy','content-fill','slide-up',"delay-" + (i + 1) + " " + (tappies.length >= 4 ? half : full) + ""], [null,null,null,true])) + "><div class=\"tappy-child content-fill block-dk block-sm\">");
jade_mixins["image"](tappy.image, 'content-ver thumbnail');
buf.push("</div></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var tappy = $$obj[i];

buf.push("<div" + (jade.attr("data-index", i, true, false)) + (jade.cls(['tappy','content-fill','slide-up',"delay-" + (i + 1) + " " + (tappies.length >= 4 ? half : full) + ""], [null,null,null,true])) + "><div class=\"tappy-child content-fill block-dk block-sm\">");
jade_mixins["image"](tappy.image, 'content-ver thumbnail');
buf.push("</div></div>");
    }

  }
}).call(this);

buf.push("</div></div></div><div class=\"details-parent content-fill\">");
// iterate tappies
;(function(){
  var $$obj = tappies;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var tappy = $$obj[i];

buf.push("<div class=\"image-details content-fill\"><div class=\"row content-lg-fill content-sm-ver content-md-ver\"><div class=\"col-lg-6 content-lg-ver image-container\">");
jade_mixins["image"](tappy.image, 'image-full-size block-v-md');
buf.push("</div><div class=\"col-lg-6 content-lg-ver\"><div class=\"caption block-v-md block-h-md text-md\">" + (null == (jade_interp = tappy.content) ? "" : jade_interp) + "</div></div></div></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var tappy = $$obj[i];

buf.push("<div class=\"image-details content-fill\"><div class=\"row content-lg-fill content-sm-ver content-md-ver\"><div class=\"col-lg-6 content-lg-ver image-container\">");
jade_mixins["image"](tappy.image, 'image-full-size block-v-md');
buf.push("</div><div class=\"col-lg-6 content-lg-ver\"><div class=\"caption block-v-md block-h-md text-md\">" + (null == (jade_interp = tappy.content) ? "" : jade_interp) + "</div></div></div></div>");
    }

  }
}).call(this);

buf.push("</div></div><div" + (jade.cls(['slide-footer','block-v-lg',submitUp ? "slide-footer--up slide-down" : "slide-up"], [null,null,true])) + ">");
if ( hasPrompt)
{
buf.push("<div class=\"slide-footer-touched\"><div class=\"btn btn-muted btn-done text-ellipsis\">" + (null == (jade_interp = doneText) ? "" : jade_interp) + "</div></div>");
if ( typeof prompt === "string")
{
buf.push("<div class=\"slide-footer-prompt text-uppercase text-bold\"><div class=\"slide-footer-prompt-content content-ver\">" + (null == (jade_interp = prompt) ? "" : jade_interp) + "</div></div>");
}
}
else
{
buf.push("<div class=\"slide-footer-prompt\"><div class=\"btn btn-muted btn-done text-ellipsis content-ver\">" + (null == (jade_interp = continueBtnText || i18n("buttons.continue")) ? "" : jade_interp) + "</div></div>");
}
if ( hasNarration)
{
buf.push("<div class=\"slide-footer-narration\"><div class=\"narration-progress btn btn-muted\"><div class=\"narration-progress-bar\"></div><div class=\"wave-ellipse\"><span class=\"bullet delay-1 block-inline\">&bullet;</span><span class=\"bullet delay-2 block-inline\">&bullet;</span><span class=\"bullet delay-3 block-inline\">&bullet;</span></div></div></div>");
}
buf.push("</div>");}.call(this,"continueBtnText" in locals_for_with?locals_for_with.continueBtnText:typeof continueBtnText!=="undefined"?continueBtnText:undefined,"doneText" in locals_for_with?locals_for_with.doneText:typeof doneText!=="undefined"?doneText:undefined,"hasNarration" in locals_for_with?locals_for_with.hasNarration:typeof hasNarration!=="undefined"?hasNarration:undefined,"hasPrompt" in locals_for_with?locals_for_with.hasPrompt:typeof hasPrompt!=="undefined"?hasPrompt:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"prompt" in locals_for_with?locals_for_with.prompt:typeof prompt!=="undefined"?prompt:undefined,"submitUp" in locals_for_with?locals_for_with.submitUp:typeof submitUp!=="undefined"?submitUp:undefined,"tappies" in locals_for_with?locals_for_with.tappies:typeof tappies!=="undefined"?tappies:undefined,"title" in locals_for_with?locals_for_with.title:typeof title!=="undefined"?title:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}